<template>
  <div id="acceptance">
    <!--<div style="font-size: 20px !important;padding-bottom: 60px;padding-top: 60px;">
      <a style="font-size: 20px !important;" href="/EntryNew/dwAcceptanceM.aspx" target="_blank">CLICK HERE</a> to open selection for official Acceptance Lists.
    </div>-->
    <div style="display: block">
      <el-row>
        <el-col :span="12">
          <h3>Select a published tournament (MD)</h3>
          <el-select
            placeholder="Select"
            value
            @change="selectTournament"
            v-model="tournamentIdentifier"
          >
            <el-option
              v-for="item in tournaments"
              :key="item.tournamentId"
              :label="item.name"
              :value="item.tournamentId"
              v-if="
                item.hasAcceptedEntriesForMainSingles &&
                item.tournamentAcceptanceListSinglesMainIsPublished
              "
            >
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                moment(item.startDate).format("MMM DD")
              }}</span>
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <h3>Select a published tournament (QLF)</h3>
          <el-select
            placeholder="Select"
            value
            @change="selectTournamentQualification"
            v-model="tournamentIdentifierQualification"
          >
            <el-option
              v-for="item in tournamentsForQualification"
              :key="item.tournamentId"
              :label="item.name"
              :value="item.tournamentId"
              v-if="
                item.hasAcceptedEntriesForQualification &&
                item.tournamentAcceptanceListSinglesQualiIsPublished
              "
            >
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                moment(item.startDate).format("MMM DD")
              }}</span>
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <div v-if="!entries" class="result-area" :key="componentKey">
        <i
          >No data to display currently. Either you have not selected a
          tournament or the tournament you have selected has no acceptance list
          yet.</i
        >
      </div>

      <div v-if="entries && entries.edition" :key="componentKey">
        <el-alert
          style="margin-top: 15px"
          type="warning"
          :closable="false"
          v-if="
            entries.edition.additionalTournamentInformationSinglesQualification.trim() !==
              '' && entries.mode === 'Qualification'
          "
        >
          <div style="font-size: 16px">
            {{
              entries.edition
                .additionalTournamentInformationSinglesQualification
            }}
          </div>
        </el-alert>

        <el-alert
          style="margin-top: 15px"
          type="warning"
          :closable="false"
          v-if="
            entries.edition.additionalTournamentInformationSinglesMain.trim() !==
              '' && entries.mode !== 'Qualification'
          "
        >
          <div style="font-size: 16px">
            {{ entries.edition.additionalTournamentInformationSinglesMain }}
          </div>
        </el-alert>

        <table style="width: 100%" class="result-area">
          <tr>
            <td>Tournament Name: {{ entries.edition.name }}</td>
            <td>
              Tournament Level: {{ tourLevelFormatter(entries.edition.level) }}
            </td>
          </tr>
          <tr>
            <td>Surface: {{ entries.edition.surface }}</td>
            <td>Prize Money: {{ entries.edition.prizeMoney | toCurrency }}</td>
          </tr>
          <tr>
            <td>
              Week of Year: {{ moment(entries.edition.startDate).week() }},
              Start:
              {{ moment(entries.edition.startDate).format("DD MM YYYY") }}
            </td>
            <td>
              Draw Size: {{ entries.edition.single.main.size }} MD /
              {{ entries.edition.single.qualification.size }}
              QLF
            </td>
          </tr>
          <tr>
            <td>
              Byes: {{ entries.edition.single.main.numberOfByes }} MD /
              {{ entries.edition.single.qualification.numberOfByes }} QLF
            </td>
            <td>
              Wildcards: {{ entries.edition.single.main.numberOfWildcards }} MD
              / {{ entries.edition.single.qualification.numberOfWildcards }} QLF
            </td>
          </tr>
          <tr>
            <td>
              MD Direct-IN: {{ entries.edition.single.main.numberOfDirects }}
            </td>
            <td>
              QLF Direct-IN:
              {{ entries.edition.single.qualification.numberOfDirects }}
            </td>
          </tr>
          <tr v-if="tournamentHasConfirmedTop10Player">
            <td>This tournament has exemption player(s)</td>
            <td>
              <span v-for="player in tournamentConfirmedPlayers">
                {{ player.lastName }},{{ player.firstName }}
              </span>
            </td>
          </tr>
        </table>

        <h3 style="padding-top: 20px">
          Acceptance List for {{ entries.edition.name }} ({{
            (entries.mode === "Qualification" ? "QLF" : "MD").toUpperCase()
          }})
        </h3>
        <div class="result-area">
          This is the final Acceptance List. Top 10 players for International
          events are not automatically accepted, unless confirmed by the
          tournament.
        </div>

        <h2>{{ entries.mode }} Draw</h2>
        <el-table
          style="width: 100%"
          :border="true"
          :data="entries.draw"
          @hook:updated="tableUpdated"
          class="entries"
          :row-style="rowStyleMain"
        >
          <el-table-column
            label="Pos"
            type="index"
            width="60"
          ></el-table-column>
          <el-table-column label="Player" width="500">
            <template slot-scope="scope"
              ><span v-bind:style="!scope.row.isInDraw ? 'text-decoration: line-through; font-size: 12px' : ''">{{ scope.row.player.lastName }},
              {{ scope.row.player.firstName }}
              {{ suppressBlrRusNationality(scope.row.player.nationality)
              }}<i class="exemption-player">{{
                scope.row.isConfirmedPlayerForInternationalTournaments !== "" &&
                scope.row.isConfirmedPlayerForInternationalTournaments !== null
                  ? "Exemption Player"
                  : ""
                }}</i></span>
            </template>
          </el-table-column>
          <el-table-column label="Rank" width="100">
            <template slot-scope="scope"
              >{{ scope.row.rank }}
              {{ scope.row.withSpecialRank ? "(SR)" : "" }}
            </template>
          </el-table-column>
          <el-table-column label="Within">
            <template slot-scope="scope">{{
              scope.row.within | fromWithin
            }}</template>
          </el-table-column>
        </el-table>

        <h2 style="padding-top: 20px">{{ entries.mode }} Draw Alternates</h2>
        <el-table
          style="width: 100%"
          :border="true"
          :data="entries.alternates"
          @hook:updated="tableUpdated"
          class="entries"
          :row-style="rowStyleAlternates"
        >
          <el-table-column
            label="Pos"
            type="index"
            width="60"
          ></el-table-column>
          <el-table-column label="Player" width="400">
            <template slot-scope="scope"
              ><span v-bind:style="!scope.row.isInAlt ? 'text-decoration: line-through; font-size: 12px' : ''">{{ scope.row.player.lastName }},
              {{ scope.row.player.firstName }}
              {{ suppressBlrRusNationality(scope.row.player.nationality) }}
              <i class="exemption-player">{{
                scope.row.isConfirmedPlayerForInternationalTournaments !== "" &&
                scope.row.isConfirmedPlayerForInternationalTournaments !== null
                  ? "Exemption Player"
                  : ""
                }}</i></span>
            </template>
          </el-table-column>
          <el-table-column label="Rank">
            <template slot-scope="scope"
              >{{ scope.row.rank }}
              {{ scope.row.withSpecialRank ? "(SR)" : "" }}
            </template>
          </el-table-column>
          <el-table-column label="Preference">
            <template slot-scope="scope">{{
              scope.row.preference | toNumber
            }}</template>
          </el-table-column>
          <el-table-column label="Within">
            <template slot-scope="scope">{{
              scope.row.within | fromWithin
            }}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      tournamentIdentifier: "",
      tournamentIdentifierQualification: "",
      componentKey: 0,
      tournamentHasConfirmedTop10Player: false,
      tournamentConfirmedPlayers: [],
    };
  },
  computed: {
    ...mapGetters("singlesEntrySystem", ["acceptedEntries", 'tournamentsForAcceptanceList']),
    entries() {
        this.componentKey; // very dirty hack to have this re-evaluated by trigger
        if (this.tournamentIdentifier !== "") {
          return this.acceptedEntries[this.tournamentIdentifier];
        } else {
          return this.acceptedEntries[
            this.tournamentIdentifierQualification
          ];
        }
      },
    tournaments() {
        return this.tournamentsForAcceptanceList;
      },
    tournamentsForQualification() {
        return this.tournamentsForAcceptanceList;
      },
  },
  methods: {
    ...mapActions("singlesEntrySystem", ["fetchAcceptanceList"]),
    rowStyleMain(row) {
      return row.row.accepted
        ? ""
        : "text-decoration: line-through; font-size: 10px;";
    },
    rowStyleAlternates(row) {
      return row.row.entered
        ? ""
        : "text-decoration: line-through; font-size: 10px;";
    },
    selectTournament(tournamentIdentifier) {
      this.tournamentIdentifierQualification = "";
      let loader = Loading.service({
        target: "#selection-tabs",
        fullscreen: false,
      });
      let that = this;
      this.fetchAcceptanceList([tournamentIdentifier, "M"])
        .then(() => {
          this.tournamentHasTop10PlayersAccepted(
            this.acceptedEntries[tournamentIdentifier]
          );
          that.$nextTick(() => {
            that.componentKey += 1;
            loader.close();
          });
        })
        .catch((error) => {
          that.$notify.error({
            title: "Error",
            message: error,
            duration: 0,
          });
          that.$nextTick(() => {
            that.componentKey += 1;
            loader.close();
          });
        });
    },
    selectTournamentQualification(tournamentIdentifier) {
      this.tournamentIdentifier = "";
      let loader = Loading.service({
        target: "#selection-tabs",
        fullscreen: false,
      });
      let that = this;
      this.fetchAcceptanceList([tournamentIdentifier, "Q"])
        .then(() => {
          this.tournamentHasTop10PlayersAccepted(
            this.acceptedEntries[tournamentIdentifier]
          );
          that.$nextTick(() => {
            that.componentKey += 1;
            loader.close();
          });
        })
        .catch((error) => {
          that.$notify.error({
            title: "Error",
            message: error,
            duration: 0,
          });
          that.$nextTick(() => {
            that.componentKey += 1;
            loader.close();
          });
        });
    },
    tournamentHasTop10PlayersEntered(entriesSelected) {
      if (entriesSelected !== undefined) {
        this.tournamentConfirmedPlayers = [];
        this.tournamentHasConfirmedTop10Player = false;
        entriesSelected.alternates.forEach((entry) => {
          if (
            entry.isConfirmedPlayerForInternationalTournaments !== undefined &&
            entry.isConfirmedPlayerForInternationalTournaments !== "" &&
            entry.isConfirmedPlayerForInternationalTournaments !== null
          ) {
            this.tournamentHasConfirmedTop10Player = true;
            this.tournamentConfirmedPlayers.push(entry.player);
          }
        });
      }
    },
    tournamentHasTop10PlayersAccepted(entriesSelected) {
      if (entriesSelected !== undefined) {
        this.tournamentConfirmedPlayers = [];
        this.tournamentHasConfirmedTop10Player = false;
        entriesSelected.draw.forEach((entry) => {
          if (
            entry.isConfirmedPlayerForInternationalTournaments !== undefined &&
            entry.isConfirmedPlayerForInternationalTournaments !== "" &&
            entry.isConfirmedPlayerForInternationalTournaments !== null
          ) {
            this.tournamentHasConfirmedTop10Player = true;
            this.tournamentConfirmedPlayers.push(entry.player);
          }
        });
      }
    },
    tableUpdated() {},
    suppressBlrRusNationality(string) {
      return string === "RUS" || string === "BLR" ? "" : "(" + string + ")";
    },
  },
};
</script>

<style scoped>
.attribute-element {
  display: flex;
  border: 1px solid black;
  align-items: center;
}

.attribute-element .label {
  border-right: 1px solid black;
  padding: 4px;
  min-width: 100px;
  background-color: dimgray;
  color: white;
}

.attribute-element .data {
  width: 100%;
  padding-left: 6px;
  padding-top: 2px;
}

.result-area {
  margin-top: 2em;
}
.exemption-player {
  color: #775cb3;
  font-weight: 600;
  font-size: 12px;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Acceptance.vue